var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh","display":"flex","overflow":"hidden"},attrs:{"id":"wrapper"}},[_c('div',{staticStyle:{"flex":"1","width":"100%","height":"100%"},attrs:{"id":"wrapper-sidemenu"}},[_c('side-menu')],1),_c('div',{staticStyle:{"flex":"9","width":"100%","height":"100%","overflow":"auto"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }